import { QualifiedFeature } from "fe-common/graphql";
import { Relations, KahunCategories } from "shared";

export class FeatureUtil {
  public static findingUsesLevel(qf: QualifiedFeature) {
    return (
      qf?.feature?.qualifierSpec?.some(
        (s) => s.relation.id === Relations.LEVEL,
      ) || qf?.mandatory?.relation.id === Relations.LEVEL
    );
  }

  public static isProcedure(qf: QualifiedFeature) {
    return qf?.feature.category.id === KahunCategories.PROCEDURE;
  }
}
